export default "__VITE_PUBLIC_ASSET__b309dc1f__"